// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"fae7338c","453":"2cab9852","473":"ea7d412a","549":"a32bde87"}[chunkId] + ".chunk.js";
};